<template>
  <div class="p-3">
    <div class="d-flex align-items-center mb-4">
        <b-button variant="light" @click="goback()" class="mr-3 rounded-circle shadow-sm">
            <b-icon icon="arrow-left"></b-icon>
        </b-button>
        <h4 class="mb-0 font-weight-bold text-dark">{{ $route.query.desc }}</h4>
    </div>
    <div>
       
      <div id="viewer"></div>
     
    </div>
  </div>
</template>

<script>
 
export default {
  methods: {
      goback() {
            this.$router.go(-1)
        },

  },
  name: 'app',
  data () {
    return {
      params: JSON.parse( this.$route.query.data)
    }
  },
  mounted: function() {
    //console.log( window.Stimulsoft)
  //  window.Stimulsoft.Base.StiLicense.loadFromFile('license.key')
   // window.Stimulsoft.Base.StiLicense.loadFromFile("license.key"); 
   // console.log('Loading Viewer view');
    
   // console.log('Creating the report viewer with default options');
    var viewer = new window.Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);

   // console.log('Creating a new report instance');
    
    var report = new window.Stimulsoft.Report.StiReport();

 //   console.log('Load report from url');
    report.loadFile('/reports/'+this.$route.params.rptname);

    var dataSet = new window.Stimulsoft.System.Data.DataSet("trail_balance");
    var param= "?fromdate="+this.params.fromdate+"&todate="+this.params.todate+"&branch_id="+this.params.branch_id 
    dataSet.readJsonFile('http://localhost:3000/trail_balance'+param,this.params);//one JSON object

    //this line of code added,too.
    report.dictionary.databases.clear();
    report.regData("trail_balance", "trail_balance", dataSet);
    report.setVariable('caption', this.params.caption);
    //this line of code is also required.
    report.dictionary.synchronize();

  //  console.log('Assigning report to the viewer, the report will be built automatically after rendering the viewer');
    viewer.report = report;

   // console.log('Rendering the viewer to selected element');
    viewer.renderHtml('viewer');

  //  console.log('Loading completed successfully!');

  }
}
</script>

<style>

</style>
